import { defaultIconColor } from './constants';
import { SVGComponentPropsType } from './types';

const defaultSize = 24;

export default ({
  color = defaultIconColor,
  size = defaultSize,
  outlined = false,
  ...props
}: SVGComponentPropsType) => (
  <svg
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    height={size}
    width={size}
    viewBox={`0 0 ${defaultSize} ${defaultSize}`}
    {...props}
  >
    <path
      d="m3.2 10.5-.7-.7.7.7a4 4 0 0 0 1.4-3.6h-1 1a2 2 0 0 1 2.2-2.3 4 4 0 0 0 3.6-1.3l-.7-.7.7.7.1-.1a2 2 0 0 1 3 0l.7-.7-.7.7a4 4 0 0 0 3.6 1.4 2 2 0 0 1 2.3 2.2 4 4 0 0 0 1.3 3.6l.1.1a2 2 0 0 1 0 3 4 4 0 0 0-1.4 3.6 2 2 0 0 1-2.2 2.3 4 4 0 0 0-3.6 1.3l-.1.1a2 2 0 0 1-3 0 4 4 0 0 0-3.6-1.4 2 2 0 0 1-2.3-2.2 4 4 0 0 0-1.3-3.6l-.7.7.7-.7-.1-.1a2 2 0 0 1 0-3ZM8 16l8-8"
      stroke={color}
      strokeWidth="2"
    />
    <circle cx="9" cy="9" r="1" stroke={color} strokeWidth="2" />
    <circle cx="15" cy="15" r="1" stroke={color} strokeWidth="2" />
  </svg>
);
